module.exports = __webpack_public_path__ + "media/components/images/flows/3-e3c2c91ff6db8c2b0f30be161d9d5dbc.svg";